import { PriceDataPoint } from 'components/dataPoints/PriceDataPoint';

type Props = {
    data?: number;
};

export const SalesPriceDataPoint = ({ data }: Props): JSX.Element => (
    <PriceDataPoint data={data} textId="salesPrice" />
);
